import { useContext } from "react";

import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";

import TransformContext from "../store/transform-context";

function Original(props) {
  const transformContext = useContext(TransformContext);

  function fetchHandler() {
    // Clear the output
    transformContext.setHtml("");

    var prefix = "";
    // var prefix = "http://localhost:5000"; // For testing

    fetch(prefix + "/random_sentence", {
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw(new Error("Servicio no disponible"));
        }
      })
      .then((json) => {
          transformContext.setPhrase(json.frase);
      })
      .catch((err) => {transformContext.setPhrase(err.message);});
  }

  return (
    <Row>
      <Col sm="10">
        <div
          className="phrase"
          contentEditable="true"
          suppressContentEditableWarning={true}
          onBlur={(e) => {
            transformContext.setPhrase(e.currentTarget.textContent);
          }}
        >
          {transformContext.phrase}
        </div>
      </Col>
      <Col sm="2">
        <div>
          <button className="ui button phrase" onClick={fetchHandler}>
            <span>
              <FontAwesomeIcon icon={faRefresh} />
            </span>
          </button>
        </div>
      </Col>
    </Row>
  );
}

export default Original;
